import type { FieldHook } from 'payload';

export const formatSlug = (val: string): string =>
  val
    .normalize('NFD') // Decompose special characters into base letters and diacritical marks
    .replace(/[\u0300-\u036f]/g, '') // Remove diacritical marks
    .replace(/[öäüõ]/g, (match) => {
      // Map special characters to replacements
      const charMap: { [key: string]: string } = {
        ö: 'o',
        ä: 'a',
        ü: 'u',
        õ: 'o',
      };
      return charMap[match] || match;
    })
    .replace(/ /g, '-') // Replace spaces with hyphens
    .replace(/[^\w-]+/g, '') // Remove invalid characters
    .replace(/-+/g, '-') // Collapse multiple dashes into a single dash
    .replace(/^-|-$/g, '') // Trim leading or trailing dashes
    .toLowerCase();

export const formatSlugHook =
  (fallback: string): FieldHook =>
  ({ data, operation, value }) => {
    if (typeof value === 'string') {
      return formatSlug(value);
    }

    if (operation === 'create' || !data?.slug) {
      const fallbackData = data?.[fallback] || data?.[fallback];

      if (fallbackData && typeof fallbackData === 'string') {
        return formatSlug(fallbackData);
      }
    }

    return value;
  };
